// Constants
import {
  CUSTOMER_APPLY_SUCCESS,
  APPLICANT_RESPONSE_ERROR,
  HYDRATE_APPLICANT,
  CLEAR_APPLICANT_ERROR,
  CUSTOMER_FORM_ERROR,
  CUSTOMER_RESPONSE_ERROR,
  CUSTOMER_PASSWORD_CREATED,
  GET_MARKETS_SUCCESS,
  CLEAR_MARKETS,
  INVALIDATE_ZIPCODE,
  SEND_VERIFICATION_SUCCESS,
  RESET_STORED_DATA,
  LOAD_APPS_SUCCESS
} from '../constants'
import { phone } from '@src/shared/utils/format'

const initialState = {
  error: '',
  data: undefined,
  created: false,
  passwordSet: false,
  userMarket: undefined,
  validMarkets: undefined,
  noMarketsFound: false,
  loaded: false,
  codeSent: false,
  prevApply: null,
  apps: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET_STORED_DATA: {
      return { ...initialState }
    }

    case CUSTOMER_PASSWORD_CREATED: {
      return {
        ...state,
        error: undefined,
        passwordSet: true
      }
    }

    case CUSTOMER_APPLY_SUCCESS: {
      return {
        ...state,
        error: undefined,
        created: true,
        data: action.data,
        prevApply: action.params
      }
    }

    case APPLICANT_RESPONSE_ERROR: {
      return {
        ...state,
        error: action.error,
        loaded: true
      }
    }

    case HYDRATE_APPLICANT: {
      return {
        ...state,
        error: undefined,
        data: action.data,
        loaded: true
      }
    }

    case CUSTOMER_FORM_ERROR:
    case CUSTOMER_RESPONSE_ERROR:
    case CLEAR_APPLICANT_ERROR: {
      return {
        ...state,
        error: undefined,
        loaded: false
      }
    }

    case INVALIDATE_ZIPCODE: {
      return {
        ...state,
        zipcodeValid: false
      }
    }

    case GET_MARKETS_SUCCESS: {
      return {
        ...state,
        validMarkets: action.data.map(market => ({ ...market, distance: parseInt(market.distance, 10) }))
      }
    }

    case SEND_VERIFICATION_SUCCESS: {
      return {
        ...state,
        error: undefined,
        codeSent: true
      }
    }

    case LOAD_APPS_SUCCESS: {
      return {
        ...state,
        apps: action.data
      }
    }

    case CLEAR_MARKETS: {
      return {
        ...state,
        validMarkets: initialState.validMarkets
      }
    }

    default:
      return state
  }
}

const applicant = state => selectApplicant(state) || {}

export const decodeReroute = reroute =>
  reroute ? Buffer.from(decodeURIComponent(reroute), 'base64').toString() : undefined

export const selectError = ({ applicant: { error } }) => (error || {}).message
export const selectErrors = ({ applicant: { error } }) => error?.errors
export const selectStatus = ({ applicant: { error } }) => (error || {}).status
export const selectLoaded = ({ applicant: { loaded } }) => loaded
export const selectApplicant = ({ applicant }) => applicant.data
export const selectPasswordSet = ({ applicant }) => applicant.passwordSet
export const selectApplicantStatus = ({ applicant: { error } }) => (error || {}).status
export const selectApplicantCreated = ({ applicant }) => applicant.created
export const selectPrevApply = ({ applicant }) => applicant.prevApply

export const selectEmailMatch = state => applicant(state).email_match
export const selectPhoneMatch = state => applicant(state).phone_match
export const selectNewCustomer = state => applicant(state).new_customer
export const selectApplicantId = state => applicant(state).id
export const selectUserMarket = ({ applicant: { userMarket } }) => userMarket
export const selectValidMarkets = ({ applicant: { validMarkets } }) => validMarkets
export const selectZipcodeValid = ({ applicant: { zipcodeValid } }) => zipcodeValid
export const selectApplicantPhone = state => phone(applicant(state).phone)
export const selectApplicantEmail = state => applicant(state).email
export const selectApplicantForgotKey = state => applicant(state).reset_key
export const selectApplicantCustomerId = state => applicant(state).customer_id
export const selectApplicantRejected = state => applicant(state).status === 'in-progress'
export const selectReroute = state => decodeReroute(applicant(state).reroute)
export const selectApps = ({ applicant }) => applicant.apps
export const selectApp = (state, os) =>
  (selectApps(state).find(app => app.app_name === `${os.toLowerCase()}-runner`) || {}).dist_url_production
